import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpDeleteBulkExperienceVettingPhotoOptions,
	httpDeleteBulkExperienceVettingPhoto
} from '@/features/experience-vetting/http/experience-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useDeleteExperienceVettingPhotos = (
	urlParams: HttpDeleteBulkExperienceVettingPhotoOptions['urlParams'],
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpDeleteBulkExperienceVettingPhotoOptions['params']
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (params) =>
			httpDeleteBulkExperienceVettingPhoto({ urlParams, params }),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: async (data, variables, onMutateResult, context) => {
			await queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE_VETTING_GALLERY_IMAGES]
			})
			await queryClient.invalidateQueries({
				queryKey: [
					QUERY_KEYS.EXPERIENCE_VETTING,
					urlParams.experienceId
				]
			})
			await options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
